export function hasCookieConsent(): boolean | null {
  if (typeof document === 'undefined') return null;
  const cookies = document.cookie.split(';').map((c) => c.trim());

  if (cookies.some((c) => c.startsWith('cookieConsent=declined'))) return false;
  if (cookies.some((c) => c.startsWith('cookieConsent=true'))) return true;

  // Soft-consent default: treat as accepted until declined
  return true;
}
